import * as React from 'react';
import './Carousel.scss';
import Carousel from 'nuka-carousel';
import shortid from 'shortid';
import WidgetContainer from '../WidgetContainer/WidgetContainer';
import {
  getTitleByWidget,
  getColorByWidget,
  getSubTitleByWidget
} from './helper';

type Props = {
  widgets: Array,
  deviceWidth: number
};

class WidgetCarousel extends React.PureComponent<Props> {
  constructor(props) {
    super(props);
  }
  render() {
    let { widgets } = this.props;
    const { deviceWidth } = this.props;
    let carouselItem = 3;
    if (deviceWidth > 1000) {
      carouselItem = 3;
    } else if (deviceWidth > 600) {
      carouselItem = 2;
    } else {
      carouselItem = 1;
    }

    widgets = widgets.filter(w =>
      [1, 5, 7, 11, 12, 13, 14].includes(w.template.id)
    );
    widgets = [...widgets, ...widgets]; //fix for gray background when scroll

    return (
      <Carousel
        slidesToShow={carouselItem}
        autoplay
        autoplayInterval={10000}
        className="carousel-container"
        slidesToScroll={1}
        withoutControls
        wrapAround
      >
        {widgets.map(widget => (
          <WidgetContainer
            key={shortid.generate()}
            title={getTitleByWidget(widget)}
            subTitle={getSubTitleByWidget(widget)}
            building={widget.building}
            color={getColorByWidget(widget)}
            widgetId={widget.template.id}
            {...widget}
          />
        ))}
      </Carousel>
    );
  }
}

export default WidgetCarousel;
